import React from 'react';

/**
 * ChefCoinIcon - SVG icon for ChefCoins, scalable and theme-friendly.
 * Usage: <ChefCoinIcon className="h-5 w-5" />
 */
const ChefCoinIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className = '', ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="ChefCoin"
    {...props}
  >
    <defs>
      <linearGradient id="goldGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFD700" stopOpacity="1" />
        <stop offset="100%" stopColor="#DAA520" stopOpacity="1" />
      </linearGradient>
      <filter id="shadow1">
        <feDropShadow dx="0" dy="0" stdDeviation="4" floodColor="#000000" floodOpacity="0.2" />
      </filter>
    </defs>
    <circle cx="100" cy="100" r="90" fill="url(#goldGradient1)" filter="url(#shadow1)" />
    <circle cx="100" cy="100" r="80" fill="#F5C518" />
    <polygon points="100,60 140,100 100,140 60,100" fill="#DAA520" />
  </svg>
);

export default ChefCoinIcon;
